<template>
  <div>
  <div class="part" v-if="dataSet.whollyObtained=='0'">
    <div class="fta_desc">
      <div class="caption">概述</div>
      <div class="desc_wrap">
        <ul>
          <li v-for="(item, index) in rules" :key="`rule-${index}`">
            <svg-icon icon-class="tips"></svg-icon>
            <span class="title">{{item.name}}</span><span class="desc">{{item.desc}}</span>
          </li>
        </ul>
      </div>
    </div>
    <div v-if="dataSet.status == 1" style="font-size: 16px;padding: 10px;background: #f2f2f2!important;width: 100%; margin-bottom:15px;font-weight: 700;color:#333">判定结果：<span style="color:blue">符合</span>   
       <!-- <span style="font-size: 16px; padding: 10px; width:100%" v-if="dataSet.originCountry">原产国：{{ dataSet.originCountry}}</span> -->
      </div>
    <div v-if="dataSet.status == 0" style="font-size: 16px;padding: 10px;background: #f2f2f2!important;width: 100%; margin-bottom:15px;font-weight: 700;color:#333">判定结果：<span style="color:red">不符合</span></div>
     <div style="margin-bottom:15px">
              <table style="width: 100%;  margin-top: 8px;" class="table2">
    
                <tbody>
                  <tr>
                    <td class="td-title-align;" style="background: rgb(242, 242, 242) !important; font-weight: bold;text-align:center">
                      原产地标准
                    </td>
                    <td class="td-title-align;" style="background: rgb(242, 242, 242) !important; font-weight: bold; width:120px;text-align:center">
                      判定结果
                    </td>
                    <td class="td-title-align;" style="background: rgb(242, 242, 242) !important; font-weight: bold;text-align:center" >
                      规则判定结果
                    </td>
                    <td class="td-title-align;" style="background: rgb(242, 242, 242) !important; font-weight: bold; width:120px;text-align:center">
                      改进意见
                    </td>
                   
                   
                </tr>
               
                <tr>
                    <td class="td-title-align">
                      <div class="name" v-if="dataSet.wo == 1 || dataSet.wo == 3">原产材料生产</div>
                   
                      <div class="name" v-else>原产材料生产</div>
                    </td>
                    <td class="td-title-align">
                     
                      <div class="name" v-if="dataSet.wo == 1"> 满足</div>
                      <div class="name" v-else>不满足</div>
                    </td>
                    <td class="td-title-align" >
                      <span class="rule_ok" v-if="dataSet.wo == 1 || dataSet.wo == 3">原产材料生产</span>
                
                      <span v-else>原产材料生产</span>
                    </td>
                    <td class="td-title-align">
                      
                    </td>
                </tr>
                <tr >
                  <td class="td-title-align">
                    <div class="name" v-if="specialCraft === 1 || specialCraft == 'Y'">加工工序/化学反应</div>
                    <div class="name" v-else>加工工序/化学反应</div>
                  </td>
                  <td class="td-title-align">
                   
                    <div class="name" v-if="dataSet.goodsSpecialCraft === 1"><span v-if="dataSet.simpleProcess == 1 || dataSet.wo == 1">不适用</span><span v-else>满足</span></div>
                    <div class="name" v-else><span v-if="dataSet.simpleProcess == 1 || dataSet.wo == 1">不适用 </span><span v-else>不满足</span></div>
                  </td>
                  <td class="td-title-align"  >
                    <span class="rule_ok" v-if="dataSet.goodsSpecialCraft === 1 &&  dataSet.specialCraft">{{ dataSet.specialCraft  }}</span>
                    <span  v-else>{{ dataSet.specialCraft }}</span>
                  </td>
                  <td class="td-title-align">
                      
                  </td>
                </tr>
                <tr >
                  <td class="td-title-align">
                    <div class="name" v-if="isMeetRVC === 2">原产地判定标准区域价值成分</div>
                    <div class="name" v-else-if="isMeetRVC === 3">原产地判定标准区域价值成分</div>
                    <div class="name" v-else>原产地判定标准区域价值成分</div>
                  </td>
                  <td class="td-title-align">
                    <div class="name" v-if="isMeetRVC === 2"><span v-if="dataSet.wo == 1 || dataSet.simpleProcess == 1">不适用</span><span v-else>满足</span></div>
                    <div class="name" v-else-if="isMeetRVC === 3"><span  v-if="dataSet.wo == 1 || dataSet.simpleProcess == 1 ">不适用</span><span  v-else>不涉及</span></div>
                    <div class="name" v-else><span v-if="dataSet.wo == 1 || dataSet.simpleProcess == 1">不适用</span><span v-else>不满足</span></div>
                  </td>
                  <td class="td-title-align" >
                    
                    <Row class="items"  :gutter="24"   v-if="dataSet.wo  != 1 && dataSet.simpleProcess  != 1">
                      <Col span="12" class="item line">
                        <Row class="item_rule" :gutter="12">
                          <!-- {{dataSet.rvc | getRulesValue}} -->
                          <Col span="12" class="title">
                            <div class="rvc1" style="position:relative; top: -5px;">RVC标准：RVC 扣减公式</div>
                            <div class="rvc2" style="position:relative; top: 5px;">RVC标准：RVC 累加公式</div>
                          </Col>
                          <Col span="12" class="value">
                            <div class="rvc11" style="position:relative; top: -5px;" v-if="dataSet.rvc">
                              RVC结果：{{dataSet.goodsRvc | toPercent}}%
                              <span class="rule_ok" v-if="$options.filters.comparePercent2(dataSet.rvc, dataSet.goodsRvc)"></span>
                              <span class="rule_no" v-else-if="isMeetRVC === 1"></span>
                            </div>
                            <div class="rvc11" style="position:relative; top: -5px;visibility:hidden;" v-else>RVC结果：</div>
                            <div class="rvc22" style="position:relative; top: 5px;" v-if="dataSet.rvc && dataSet.goodsRvc2 != undefined">
                              RVC结果：{{dataSet.goodsRvc2 | toPercent}}%
                              <span class="rule_ok" v-if="$options.filters.comparePercent2(dataSet.rvc, dataSet.goodsRvc2)"></span>
                              <span class="rule_no" v-else-if="isMeetRVC === 1"></span>
                            </div>
                          </Col>
                        </Row>
                      </Col>
                     
                      <Col span="12" class="item" >
                        <!-- <Row class="item_rule" :gutter="12" v-if="!(dataSet.rvc && $options.filters.comparePercent(dataSet.rvc, dataSet.goodsRvc) && dataSet.cumulation && !$options.filters.comparePercent(dataSet.cumulation, dataSet.goodsCumulation))"> -->
                        <Row class="item_rule" :gutter="12">
                          <!-- {{dataSet.cumulation | getRulesValue}} -->
                          <Col span="12" class="title">
                            <div class="rvc1" style="position:relative; top: -5px;">累积规则标准：扣减公式</div>
                            <div class="rvc2" style="position:relative; top: 5px;">累积规则标准：累加公式</div>
                          </Col>
                          <Col span="12" class="value">
                            <div class="rvc11" style="position:relative; top: -5px;" v-if="dataSet.cumulation">
                              累积规则结果：{{dataSet.goodsCumulation | toPercent}}%
                              <span class="rule_ok" v-if="$options.filters.comparePercent2(dataSet.cumulation, dataSet.goodsCumulation)"></span>
                              <span class="rule_no" v-else-if="isMeetRVC === 1"></span>
                            </div>
                            <div class="rvc11" style="position:relative; top: -5px;visibility:hidden;" v-else>累积规则结果：</div>
                            <div class="rvc22" style="position:relative; top: 5px;" v-if="dataSet.cumulation && dataSet.goodsCumulation2 != undefined">
                              累积规则结果：{{dataSet.goodsCumulation2 | toPercent}}%
                              <span class="rule_ok" v-if="$options.filters.comparePercent2(dataSet.cumulation, dataSet.goodsCumulation2)"></span>
                              <span class="rule_no" v-else-if="isMeetRVC === 1"></span>
                            </div>
                          </Col>
                        </Row>
                     
                      </Col>
                    </Row>
                  </td>
                  <td class="td-title-align">
                     
                  </td>
                 </tr>
                 <tr >
                  <td class="td-title-align">
                    <div class="name" v-if="isMeetCTC === 2">税则归类改变标准</div>
                    <div class="name" v-else-if="isMeetCTC === 3">税则归类改变标准</div>
                    <div class="name" v-else>税则归类改变标准</div>
                  </td>
                  <td class="td-title-align">
                    <div class="name" v-if="isMeetCTC === 2"><span v-if="dataSet.wo == 1 || dataSet.simpleProcess == 1">不适用</span><span v-else>满足</span></div>
                    <div class="name" v-else-if="isMeetCTC === 3"><span  v-if="dataSet.wo == 1 || dataSet.simpleProcess == 1">不适用</span><span  v-else>不涉及</span></div>
                    <div class="name" v-else><span v-if="dataSet.wo == 1 || dataSet.simpleProcess == 1">不适用</span><span v-else>不满足</span></div>
                  </td>
                  <td class="td-title-align" >
                    <Row class="items" :gutter="24" v-if=" dataSet.wo != 1 && dataSet.simpleProcess  != 1">
                      <Col span="12" class="item line">
                        <Row class="item_rule" :gutter="12">
                          <Col span="12" class="title">CTC标准：{{dataSet.ctc || '不涉及'}}</Col>
                          <Col span="12" class="value" v-if="dataSet.ctc">
                            <div v-if="parseInt(dataSet.goodsCtc) === 1">CTC结果：<span class="rule_ok">符合</span></div>
                            <div v-else>CTC结果：不符合<span class="rule_no" v-if="isMeetCTC === 1"></span></div>
                          </Col>
                        </Row>
                        <Row class="item_rule" :gutter="12" style="margin-top: 20px;">
                          <Col span="12" class="title" > <div  style="padding-left: 6px;
                            padding-right: 6px;
                            word-break: break-all;
                            text-overflow: ellipsis;
                            overflow: hidden;
                            display: -webkit-box;
                            -webkit-line-clamp: 1;
                            -webkit-box-orient: vertical;" :title="dataSet.excludedCtc || '不涉及'">排除章节：{{dataSet.excludedCtc || '不涉及'}}</div></Col>
                          <Col span="12" class="value" v-if="dataSet.excludedCtc">
                            <div v-if="parseInt(dataSet.goodsExcludedCtc) === 1">排除章节结果：<span class="rule_ok">存在排除章节</span></div>
                            <div v-else>排除章节结果：不存在排除章节<span class="rule_no" v-if="isMeetCTC === 1"></span></div>
                          </Col>
                        </Row>
                      </Col>
                   
                      <Col span="12" class="item" >
                        <Row class="item_rule" :gutter="12">
                          <Col span="12" class="title">微小含量(价格)：{{dataSet.tiny ? dataSet.tiny + '%' : '不涉及'}}</Col>
                          <Col span="12" class="value" v-if="dataSet.tiny">
                            <template v-if="dataSet.goodsTiny == 0">
                              微小含量结果：不涉及微小含量
                            </template>
                            <template v-else>
                              微小含量结果： <span v-if="dataSet.goodsTiny!=null"> {{dataSet.goodsTiny | toPercent}}%</span> <span v-else>-</span>
                            </template>
                            <span class="rule_ok" v-if="$options.filters.comparePercent(dataSet.tiny, dataSet.goodsTiny) && dataSet.goodsTiny!=null"></span>
                            <span class="rule_no" v-else-if="isMeetCTC === 1"></span>
                          </Col>
                        </Row>
                        <Row class="item_rule" :gutter="12" style="margin-top: 20px;">
                          <Col span="12" class="title">微小含量(重量)：{{dataSet.tinyWeight ? dataSet.tinyWeight + '%' : '不涉及'}}</Col>
                          <Col span="12" class="value" v-if="dataSet.tinyWeight">
                            <template v-if="dataSet.goodsTinyWeight == 0">
                              微小含量结果：不涉及微小含量
                            </template>
                            <template v-else-if="dataSet.goodsTinyWeight < 0">
                              微小含量结果：数据不全
                            </template>
                            <template v-else>
                              微小含量结果： <span v-if="dataSet.goodsTinyWeight!=null"> {{dataSet.goodsTinyWeight | toPercent}}%</span> <span v-else>-</span>  
                            </template>
                            <span class="rule_ok" v-if="$options.filters.comparePercent(dataSet.tinyWeight, dataSet.goodsTinyWeight) && dataSet.goodsTinyWeight!=null"></span>
                            <span class="rule_no" v-else-if="isMeetCTC === 1 || dataSet.goodsTinyWeight == -1"></span>
                          </Col>
                          <Col span="24" v-if="dataSet.goodsTinyWeight == -1">
                            <div class="rule_tips"><Icon type="ios-information" />判断条件涉及原材料重量，请完善原产地重量信息再判断一次</div>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </td>
                  <td class="td-title-align">
                     
                  </td>
              </tr>
              <tr>
                <td class="td-title-align">
                  <div class="name" v-if="dataSet.simpleProcess == 1 || dataSet.simpleProcess == 3">微小加工和处理</div>
               
                  <div class="name" v-else>微小加工和处理</div>
                </td>
                <td class="td-title-align">

                  <div class="name" v-if="dataSet.simpleProcess != 1"><span v-if="dataSet.wo == 1 ">不适用</span><span v-else>超出</span></div>
                  <div class="name" v-else><span v-if="dataSet.wo == 1">不适用</span><span v-else>不超出</span></div>
                
                </td>
                <td class="td-title-align" >
                  <span class="rule_ok" v-if="(dataSet.simpleProcess == 1 || dataSet.simpleProcess == 3) && dataSet.wo != 1 ">微小加工和处理</span>
            
                  <span v-else>微小加工和处理</span>
                </td>
                <td class="td-title-align">
                  
                </td>
            </tr>
             
          </tbody></table>
            </div>
  </div>
  <div class="part" v-if="dataSet.whollyObtained=='1'">
   
   
   
    <div v-if="dataSet.status == 1" style="font-size: 16px;padding: 10px;background: #f2f2f2!important;">判定结果：<span style="color:blue">通过，满足原产地完全获得或生产标准</span></div>
    <div v-if="dataSet.status == 0" style="font-size: 16px;padding: 10px;background: #f2f2f2!important;">判定结果：<span style="color:red">不通过，不满足原产地完全获得或生产标准</span></div>
    <div >
      <p style="margin: 20px 0;
      white-space: pre-wrap;     font-size: 16px;"  v-html="content"></p>
    </div>
  </div>


</div>
</template>

<script>
import Vue from 'vue'

export default {
  props: ['whollyObtained','dataSet','materials','voteStatus','imported','wo','specialCraft'],
  data () {
    return {
      content:'',
      product:{},
      material: {
        columns: [
          {title: '原材料料号', key: 'materialPN', align: 'center'},
          {title: '原材料属性', key: 'materialType', align: 'center', ellipsis: true, render: (h, params) => {
            return h('span', {
              attrs: {title: this.$options.filters.getMaterialType(params.row.materialType)}
            }, this.$options.filters.getMaterialType(params.row.materialType))
          }},
          {
            title: '原材料名称',
            key: 'materialName',
            align: 'center',
            ellipsis: true,
            render: (h, params) => {
              return h('span', {
                attrs: {title: params.row.materialName}
              }, params.row.materialName)
            }
          },
          {
            title: '原材料商品编码',
            key: 'materialCode',
            align: 'center',
            ellipsis: true,
            render: (h, params) => {
              return h('span', {
                attrs: {title: params.row.materialCode}
              }, params.row.materialCode)
            }
          },
          {
            title: '原材料单价',
            key: 'materialPrice',
            align: 'center',
            ellipsis: true,
            render: (h, params) => {
              return h('span', (this.$options.filters.amountThousands(params.row.materialPrice || 0) || '-') + params.row.materialUnit)
            }
          },
          // {title: '原材料单位', key: 'materialUnit', align: 'center', ellipsis: true, width: 120,},
          {
            title: '原材料重量',
            key: 'materialWeight',
            align: 'center',
            render: (h, params) => {
              return h('span', params.row.materialWeight || '-')
            }
          },
          {title: '原材料原产地', key: 'materialOrigin', ellipsis: true, align: 'center'},
          {
            title: '原材料备注',
            key: 'materialDescription',
            align: 'center',
            ellipsis: true,
            render: (h, params) => {
              return h('span', {
                attrs: {title: params.row.materialDescription || '-'}
              }, params.row.materialDescription || '-')
            }
          }
        ]
      }
    }
  },
  created(){
    if(this.dataSet.whollyObtained==1){
   
      let ftaData = []
      this.$api.coo.goods.getAdditional(
        { exporter: this.dataSet.exporter,importer: this.dataSet.importer, type:1 },
        {
          success: response => {
         
            if (response.data.code === 200) {
          
              ftaData = response.data.data

              for (let index = 0; index < ftaData.length; index++) {
                if(ftaData[index].fta == this.dataSet.ftaName)
                   this.content = ftaData[index].content

              
                
              }
            
            } 
            
          },
         
        }
      );

    }
  

  },
  computed: {
    
    'dataset.wo' () {
     
      let _wo = this.dataSet.wo == 1 || this.dataSet.wo == 'Y'? 1 : 0
      let _pe = this.dataSet.pe == 1 || this.dataSet.pe == 'Y'? 1 : 0
      let _imported = this.imported == 1 || this.imported == 'Y'? 1 : 0
      let _goodsWo = this.dataSet.goodsWo == 1 || this.dataSet.goodsWo == 'Y'? 1 : -1
      let _goodsPe = this.dataSet.goodsPe == 1 || this.dataSet.goodsPe == 'Y'? 1 : -1
      if (_wo && _pe) {
        if (_goodsWo == 1 && _goodsPe == -1) {
          return 1 //高亮显示 完全获取
        } else if (_imported == 1 && _goodsPe == 1) {
          return 2 //高亮显示 完全生产
        } else if (_imported == 0 && _goodsWo == -1 && _goodsPe == -1) {
          return 3 //显示不符合完全获取文案
        } else if (_imported == 1 && _goodsWo == -1 && _goodsPe == -1) {
          return 4 //显示不符合完全生产文案
        } else {
          return 0 //不显示完全获取与完全生产
        }
      } else if (!_wo && !_pe) {
        return 5 //灰色显示 完全获取
      } else { //只会同时有或同时没有，以外的情况只要系统不报错就可以了，显示不符合完全获取文案 也行
        return 3
      }
     
    },

    materialList () {
      if (this.dataSet.goodsOtherDeclare && !this._.isEmpty(this.materials)) {
        let _goods = this.dataSet.goodsOtherDeclare.split(',')
        return _.reduce(this.materials, function(res, item) {
          if (_goods.indexOf(item.materialPN) != -1) {
            res.push(item)
          }
          return res
        }, [])
      } else {
        return []
      }
    },
    rules () {
      let res = []
      let i = 1
      while (this.dataSet[`ruleName${i}`]) {
        res.push({ name: this.dataSet[`ruleName${i}`], desc: this.dataSet[`ruleDescription${i}`] || '' })
        i++
      }
      return res
    },
    isMeetRVC () {
      let res = 1
      // if (!this.dataSet.rvc && !this.dataSet.cumulation && !this.dataSet.cumulationUnderdeveloped) {
      if (!this.dataSet.rvc && !this.dataSet.cumulation) {
        res = 3
      } else if (this.dataSet.rvc && this.$options.filters.comparePercent2(this.dataSet.rvc, this.dataSet.goodsRvc)) {
        res = 2
      } else if (this.dataSet.rvc && this.$options.filters.comparePercent2(this.dataSet.rvc, this.dataSet.goodsRvc2)) {
        res = 2
      } else if (this.dataSet.cumulation && this.$options.filters.comparePercent2(this.dataSet.cumulation, this.dataSet.goodsCumulation)) {
        res = 2
      } else if (this.dataSet.cumulation && this.$options.filters.comparePercent2(this.dataSet.cumulation, this.dataSet.goodsCumulation2)) {
        res = 2
      // } else if (this.dataSet.cumulationUnderdeveloped && this.dataSet.goodsCumulationUnderdeveloped) {
      //   res = 2
      }
      return res
    },
    isMeetCTC () {
      let res = 1
      // 满足微小含量(价格)或微小含量(重量)或同时满足CTC/排除章节标准
      if (!this.dataSet.ctc && !this.dataSet.tiny && !this.dataSet.tinyWeight && !this.dataSet.excludedCtc) {
        res = 3
      } else if ((this.dataSet.ctc || this.dataSet.excludedCtc) && (!this.dataSet.ctc || (this.dataSet.ctc && parseInt(this.dataSet.goodsCtc) === 1)) && (!this.dataSet.excludedCtc || (this.dataSet.excludedCtc && parseInt(this.dataSet.goodsExcludedCtc) === 1))) {
        res = 2
      } else if (this.dataSet.tiny && this.$options.filters.comparePercent(this.dataSet.tiny, this.dataSet.goodsTiny)) {
        res = 2
      } else if (this.dataSet.tinyWeight && this.$options.filters.comparePercent(this.dataSet.tinyWeight, this.dataSet.goodsTinyWeight)) {
        res = 2
      }
      return res
    }
  },
  filters: {
    getRulesValue (rule) {
      if (!rule) return '无'
      let rules = Vue._.trim(rule || '').replace(/\s/, '').match(/^(>=|<=|>|<|=)(\d+)$/)
      let res = rule
      if (rules && rules.length === 3) {
        switch (rules[1]) {
          case '>=':
          case '>':
            res = `FOB - VNM${rule}%`
            break
          case '<=':
          case '<':
            res = `VNM${rule}%`
            break
          default:
            res = `{rule}%`
        }
      }
      return res
    },
    comparePercent (rule, value) {
      let percent = Vue._.round((parseFloat(value) || 0) * 100, 2)
      let rules = Vue._.trim(rule || '').replace(/\s/, '').match(/^(>=|<=|>|<|=)(\d+)$/)
      let res = false
      if (rules && rules.length === 3 && parseFloat(percent) >= 0) {
        switch (rules[1]) {
          case '>=':
            res = parseFloat(percent) >= (parseFloat(rules[2]) || 0)
            break
          case '<=':
            res = parseFloat(percent) <= (parseFloat(rules[2]) || 0)
            break
          case '>':
            res = parseFloat(percent) > (parseFloat(rules[2]) || 0)
            break
          case '<':
            res = parseFloat(percent) < (parseFloat(rules[2]) || 0)
            break
          case '=':
            res = parseFloat(percent) === (parseFloat(rules[2]) || 0)
            break
        }
      }
      return res
    },
    comparePercent2 (rule, value) {
      let rules = Vue._.trim(rule || '').replace(/\s/, '').match(/^(>=|<=|>|<|=)(\d+)$/)
      if (rules && rules.length === 3) {
        if ('<' == rules[1]) {
          let _rule = '>=' + (100 - (parseFloat(rules[2]) || 0))
          return this.comparePercent(_rule, value)
        } else if ('<=' == rules[1]) {
          let _rule = '>' + (100 - (parseFloat(rules[2]) || 0))
          return this.comparePercent(_rule, value)
        } else {
          return this.comparePercent(rule, value)
        }
      }
      return false
    }
  }
}
</script>
<style scoped>
.goods_other{
  margin-top: 20px;
  margin-bottom: 20px;
}
  .material_list >>> .ivu-table-wrapper{
    border: 0 none;
  }
  .material_list >>> .ivu-table{
    background-color: #fff;
    box-shadow: 0 2px 4px 0 rgba(196,196,196,0.50);
  }
  .material_list >>> .ivu-table th{
    background-color: rgba(31, 138, 252, 0.05);
    border-bottom: 0 none;
    font-size: 16px;
    font-weight: normal;
    color: #999;
  }
  .material_list >>> .ivu-table th span,.material_list >>> .ivu-table td span{
    white-space: nowrap;
  }
  .material_list >>> .ivu-table td{
    border-color: #f1f1f1;
    font-size: 16px;
  }

  .fta_desc{
    /* background-color: #F9F9F9; */
    padding: 0;
    margin-bottom: 18px;
  }
  .fta_desc .desc_wrap{
    border: 1px solid #afcada;
    padding: 12px 18px;
    border-radius: 6px;
  }
  .fta_desc li{
    font-size: 16px;
    margin-bottom: 6px;
  }
  .fta_desc li:last-child{
    margin-bottom: 0;
  }
  .fta_desc li .sn{
    background-color: #FFFFFF;
    border: 0.5px solid #1F8AFD;
    border-radius: 100%;
    color: #1F8AFD;
    font-size: 10px;
    margin-right: 5px;
    display: inline-block;
    width: 16px;
    height: 16px;
    text-align: center;
    vertical-align: middle;
    position: relative;
    top: -1px;
  }
  .fta_desc li .sn span{
    position: absolute;
    top: 50%;
    left: 50%;
    color: #0774b5;
    transform: translate(-50%, -50%);
  }
  .fta_desc li .svg-icon{
    color: #666;
    font-size: 17px;
  }
  .fta_desc li .title{
    color: #333;
    padding-right: 10px;
    font-size: 16px;
  }
  .fta_desc li .desc{
    color: #999;
  }
  .caption{
    font-size: 16px;
    color: #333;
    font-weight: bold;
    background: url("~@/assets/images/home/guide.png") 0 center no-repeat transparent;
    background-size: 12px;
    padding-left: 18px;
    margin-bottom: 16px;
    position: relative;
  }
  .special{
    /* display: flex;
    margin-left: 10px;
    margin-right: 10px; */
  }
  .special .item{
    border: 0.5px solid #D8D8D8;
    border-radius: 3px;
    position: relative;
    padding: 12px 20px;
    margin-bottom: 16px;
  }
  .special .item:last-child{
    margin-bottom: 0;
  }
  .special .item.selected{
    border-color: #0774b5;
  }
  .special .icon{
    width: 32px;
    position: absolute;
    top: 22px;
    left: 20px;
  }
  .special .item .selected_img{
    display: none;
  }
  .special .item.selected .defalut_img{
    display: none;
  }
  .special .item.selected .selected_img{
    display: block;
  }
  .special .item .wrap{
    display: flex;
    align-items: center;
  }
  .special .item .svg-icon{
    color: #999;
    font-size: 18px;
  }
  .special .item.selected .svg-icon{
    color: #0774b5;
  }
  .special .item .title{
    color: #333;
    /*font-weight: bold;*/
    font-size: 16px;
    padding-right: 10px;
    padding-left: 6px;
    white-space: nowrap;
  }
  .special .item.selected .title{
    color: #0774b5;
  }
  .special .item .desc{
    color: #999;
    font-size: 16px;
  }
  .special .ckbox_wrap{
    position: absolute;
    top: 0;
    right: 0;
    border-top-right-radius: 3px;
    border-left: 0.5px solid #D8D8D8;
    border-bottom: 0.5px solid #D8D8D8;
    padding: 2px;
  }
  .special .ckbox{
    width: 10px;
  }
  .special .ckbox.selected_ckbox{
    display: none;
  }
  .special .item.selected .ckbox{
    display: none;
  }
  .special .item.selected .ckbox_wrap{
    background-color: #0774b5;
    border-color: #0774b5;
  }
  .special .item.selected .ckbox.selected_ckbox{
    display: block;
  }
  .special_msg{
    margin: 5px 10px 0 16px;
  }
  .special_msg >>> .ivu-alert-message{
    font-size: 16px;
  }
  .special_msg >>> .ivu-alert-close{
    display: none;
  }
  .special_msg >>> .ivu-alert{
    margin-bottom: 0;
  }
  .special_msg >>> .ivu-alert:last-child{
    margin-bottom: 0;
  }
  .special_msg >>> .ivu-alert-error{
    padding-left: 18px;
    background-color: transparent;
    border: 0 none;
    color: red;
  }
  .special_msg >>> .ivu-alert-icon{
    left: 0;
    font-size: 16px;
  }
  .rule_item{
    /* box-shadow: 0 2px 4px 0 rgba(223,223,223,0.50); */
    background-color: #fff;
    margin: 20px 0;
    border: 1px solid #eaf7ff;
  }
  .rule_item .head_title{
    position: relative;
    height: 48px;
    line-height: 48px;
    background-color: #eaf7ff;
  }
  .rule_item .head_title .name{
    font-size: 16px;
    color: #333;
    /* background: url("~@/assets/images/home/guide.png") 16px center no-repeat transparent; */
    background-size: 12px;
    padding-left: 20px;
  }
  .rule_item .head_title .name span{
    color: #0470e3;
    padding-left: 5px;
  }
  .rule_item .head_title .desc{
    position: absolute;
    right: 16px;
    top: 50%;
    transform: translateY(-50%);
    font-size: 12px;
    color: #949494;
    background: url("~@/assets/images/coo/icon_tixing.png") 0 center no-repeat transparent;
    background-size: 12px auto;
    padding-left: 17px;
  }
  .rule_item .items{
    padding: 16px 18px;
    color: #333;
  }
  .rule_item .items .item.otherrule{
    font-size: 16px;
  }
  .rule_item .items .item.otherrule .svg-icon {
    color: #666;
    font-size: 17px;
    margin-right: 2px;
  }
  .rule_item .items .line{
    /* border-right: 1px dashed #ccc; */
  }
  .rule_item .items .item .item_rule{
    font-size: 16px;
    white-space: nowrap;
    border: 1px solid #ddd;
    padding: 24px 20px;
    border-radius: 6px;
    min-height: 94px;
  }
  .rule_item .items .item .item_rule:first-child{
    margin-bottom: 20px;
  }
  .rule_item .items .item .item_rule .title, .rule_item .items .item .item_rule .value{
    white-space: normal;
  }
  .rule_item .items .value{
    font-weight: bold;
  }
  .rule_ok{
    background: url("~@/assets/images/coo/icon_manzu.png") right center no-repeat transparent;
    background-size: 11px 11px;
    padding-right: 16px;
  }
  .rule_no{
    background: url("~@/assets/images/coo/icon_tx.png") right center no-repeat transparent;
    background-size: 11px 11px;
    padding-right: 16px;
  }
  .part .resource .dw{
    /*width: 150px;*/
    /*height: 212px;*/
    text-align: center;
    cursor: pointer;
  }
  .part .resource .dw:hover .title span{
    text-decoration: underline;
  }
  .part .resource .dw img{
    width: 150px;
    height: 212px;
  }
  .part .resource .dw .title{
    color: #1F8AFD;
    font-size: 13px;
    margin: 8px 0 10px;
    width: 150px;
  }
  .part .resource .dw .title span{
    background: url("~@/assets/images/coo/icon_xiazai.png") no-repeat 0 center transparent;
    background-size: 16px;
    padding-left: 18px;
  }
  .rule_tips{
    color: #f30d0d;
    font-size: 16px;
    margin-top: 5px;
  }
  .rule_tips .ivu-icon{
    margin-right: 4px;
    font-size: 16px;
    position: relative;
    top: 1px;
  }
</style>
<style scoped>
.table2 td, th {
  font-size: 16px;
  background: #fff;
  padding:20px
}
table, td, th {
  border: 1px solid #ccc;
  font-size: 16px;
  height: 22px;
  max-height: 22px;
  background: #f2f2f2;
}
.td2{
  background: #fff;
}
label{
  padding-right: 10px;
}
td{
  padding: 10px;
}
.td-title-align {
  text-align: right;
  padding-right: 2px;
}
.td-title1 {
  width: 7%;
}
table {
  border-collapse: collapse;
}
.td-content1 {
  width: 12% !important;
}
.td-title-align {
  text-align: center;
  padding-right: 2px;
}
</style>


// WEBPACK FOOTER //
// src/components/RulesDecide/zh-CN/VoteResultPanel3.vue